module.exports = __webpack_public_path__ + "static/media/github.d23f65af.svg";